import { useAuth } from '@schooly/components/authentication';
import React, { FC } from 'react';

import MainLayout from '../../components/uikit-components/MainLayout/MainLayout';
import { allowRenderApplications } from '../../helpers/renderRoutesByPermissions';
import { AccessDenied } from '@schooly/style';
import { ApplicationsContent } from './ApplicationsContent';

export const ApplicationsPage: FC = () => {
  const { permissions } = useAuth();
  const canSeeApplications = allowRenderApplications(permissions);

  const renderContent = () => {
    if (!canSeeApplications) {
      return <AccessDenied />;
    }

    return <ApplicationsContent />;
  };

  return <MainLayout>{renderContent()}</MainLayout>;
};
